module.exports = "/assets/cf13b429dcf02af0b7b36002f07caf4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/KP.png
// module id = 2677
// module chunks = 0